import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { PrepareBasketSimSelection } from "@/apps/partner/components/PrepareBasketSimSelection/PrepareBasketSimSelection";
import { AddDeviceFormType } from "@/apps/partner/types";
import {
  partnerAddDeviceStepMapping,
  partnerAddDeviceStepPaths,
} from "@/apps/partner/utils/partnerAddDevice.constants";
import { usePartnerAddDeviceContext } from "@/apps/partner/views/AddDevice/PartnerAddDeviceContext";
import { Button } from "@/components/Interface/Button/Button";
import { StepFlowNavigation } from "@/components/Layout/BaseLayouts/StepFlowLayout/StepFlowNavigation";

export const PartnerSimTypeStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setAllowedMaxStep } = usePartnerAddDeviceContext();
  const { watch, trigger } = useFormContext<AddDeviceFormType>();
  const simType = watch("simType");

  const handleContinue = async () => {
    const isValid = await trigger("simType");

    if (!isValid) {
      return;
    }

    setAllowedMaxStep(partnerAddDeviceStepMapping["rate-selection"].step);
    navigate(partnerAddDeviceStepPaths["rate-selection"]);
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <PrepareBasketSimSelection />

      <StepFlowNavigation
        primaryButton={
          <Button
            variant="primary"
            disabled={!simType}
            onClick={() => void handleContinue()}
          >
            {t("Common.label.forward")}
          </Button>
        }
        secondaryButton={
          <Button variant="secondary" disabled>
            {t("Common.label.back")}
          </Button>
        }
      />
    </div>
  );
};
